import type { RouteRecordRaw } from 'vue-router';

import { settingsLayoutComponents, settingsLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

import { CollaboratorsRoute, GeneralRoute } from './components/routes';

const SettingsRoute: RouteRecordRaw = {
	path: '/settings',
	name: ROUTE_KEYS.SETTINGS,
	meta: {
		label: 'settings.page-title',
		auth: true
	},
	props: {
		...settingsLayoutProps
	},
	components: {
		default: () => import('./settings.page.vue'),
		...settingsLayoutComponents
	},
	redirect: () => GeneralRoute,
	children: [GeneralRoute, CollaboratorsRoute]
};

export default SettingsRoute;
